import { BrowserRouter, Routes, Route } from "react-router-dom";  
import './App.css';  

// Components  
import Layout from "./Components/Layout";  
import RequiredAuth from "./Components/RequiredAuth"; 
import Dashboard from "./Components/Dashboard";  
import Home from "./Components/Home";  
import About from "./Components/About";  
import Properties from "./Components/Properties";  
import Gallery from "./Components/Gallery";  
import Contact from "./Components/Contact";  
import Blog from "./Components/Blog";
import { AuthProvider } from "./contex/AuthProvider";   
import { TokenProvider } from "./contex/TokenProvider";

// Pages  
import LoginSignUp from "./Login and Signup/LoginSignUp";  
import RealEstateForm from './pages/RealEstateForm';  
import EducationForm from './pages/EducationForm';  
import LegalConsultForm from './pages/LegalConsultForm';  
import FtPropertyOne from './pages/FtPropertyOne';  
import DelightEstate from "./pages/DelightEstate";  
import FarmEstate from "./pages/FarmEstate";  
import FeaturedProperties from "./pages/FeaturedProperties";  
import AddProperties from "./properties/AddProperties";  
import EditProperties from "./properties/EditProperties";  
import ViewProperties from "./properties/ViewProperties";  
import ViewFeturedProperties from "./FeturedProperties/ViewFeturedProperties";  
import AddImage from "./Gallery/AddImage";
import HomeSliderView from "./Homehelp/HomeSliderView";


function App() {  
  return (  
    <TokenProvider>
      <AuthProvider>
          <Routes>
            <Route index element={<LoginSignUp />} />
            <Route path="/" element={<Layout />}>
              <Route element={<RequiredAuth />}>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/home" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/properties" element={<Properties />} />
                <Route path="/gallery" element={<Gallery />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/realestateform" element={<RealEstateForm />} />
                <Route path="/educationform" element={<EducationForm />} />
                <Route path="/legalconsultform" element={<LegalConsultForm />} />
                <Route path="/ftpropertyone" element={<FtPropertyOne />} />
                <Route path="/delightestate" element={<DelightEstate />} />
                <Route path="/farmestate" element={<FarmEstate />} />
                <Route path="/featuredproperties" element={<FeaturedProperties />} />
                <Route path="/addproperties" element={<AddProperties />} />
                <Route path="/editproperties/:id" element={<EditProperties />} />
                <Route path="/viewproperties/:id" element={<ViewProperties />} />
                <Route path="/viewfeturedproperties/:id" element={<ViewFeturedProperties />} />
                <Route path="/addimage/:id" element={<AddImage />} />
                <Route path="/homesliderview" element={<HomeSliderView />} />
              </Route>
            </Route>
          </Routes>
      </AuthProvider>
    </TokenProvider>
    
  );  
}  

export default App;